import { all, call, cancelled, put, spawn, takeLatest } from 'redux-saga/effects';
import { ReduxAction } from 'types/redux.types';
import actions from './actions';
import fetchPackagesGraphql, {
  fetchHighlightedPackagesQuery,
  fetchSocialPostingPackagesQuery,
  fetchTopResultPackagesQuery,
} from './graphql';

function* fetchPackagesGenerator(action: ReduxAction): Generator<any> {
  try {
    const response = yield call(fetchPackagesGraphql, action.payload);
    yield put({
      type: actions.FETCH_PACKAGES_DONE,
      payload: (response as any).data.companyPackages,
    });
  } catch (e: any) {
    if (e.message.indexOf('access.denied') !== -1) {
      yield put({ type: actions.FETCH_PACKAGES_DENIED });
    }
    yield put({ type: actions.FETCH_PACKAGES_ERROR });
  } finally {
    if (yield cancelled()) {
      yield put({
        type: actions.FETCH_PACKAGES_CANCELLED,
      });
    }
  }
}

export function* fetchSocialPostingPackagesGenerator(): Generator<any> {
  try {
    const response = yield call(fetchSocialPostingPackagesQuery);
    yield put({
      type: actions.FETCH_SOCIAL_POSTING_PACKAGES_DONE,
      payload: (response as any).data.socialNetworkPackages,
    });
  } catch (e: any) {
    if (e.message.indexOf('access.denied') !== -1) {
      yield put({ type: actions.FETCH_SOCIAL_POSTING_PACKAGES_DENIED });
    }
    yield put({ type: actions.FETCH_SOCIAL_POSTING_PACKAGES_ERROR });
  } finally {
    if (yield cancelled()) {
      yield put({
        type: actions.FETCH_SOCIAL_POSTING_PACKAGES_CANCELLED,
      });
    }
  }
}

export function* fetchHighlightedPackagesGenerator(): Generator<any> {
  try {
    const response = yield call(fetchHighlightedPackagesQuery);
    yield put({
      type: actions.FETCH_HIGHLIGHTED_PACKAGES_DONE,
      payload: (response as any).data.highlightedPackages,
    });
  } catch (e: any) {
    if (e.message.indexOf('access.denied') !== -1) {
      yield put({ type: actions.FETCH_HIGHLIGHTED_PACKAGES_DENIED });
    }
    yield put({ type: actions.FETCH_HIGHLIGHTED_PACKAGES_ERROR });
  } finally {
    if (yield cancelled()) {
      yield put({
        type: actions.FETCH_HIGHLIGHTED_PACKAGES_CANCELLED,
      });
    }
  }
}

export function* fetchTopResultPackagesGenerator(): Generator<any> {
  try {
    const response = yield call(fetchTopResultPackagesQuery);
    yield put({
      type: actions.FETCH_TOP_RESULT_PACKAGES_DONE,
      payload: (response as any).data.topResultPackages,
    });
  } catch (e: any) {
    if (e.message.indexOf('access.denied') !== -1) {
      yield put({ type: actions.FETCH_TOP_RESULT_PACKAGES_DENIED });
    }
    yield put({ type: actions.FETCH_TOP_RESULT_PACKAGES_ERROR });
  } finally {
    if (yield cancelled()) {
      yield put({
        type: actions.FETCH_TOP_RESULT_PACKAGES_CANCELLED,
      });
    }
  }
}

export function* fetchPackages() {
  yield takeLatest(actions.FETCH_PACKAGES_START, fetchPackagesGenerator);
}

export function* fetchSocialPostingPackages() {
  yield takeLatest(
    actions.FETCH_SOCIAL_POSTING_PACKAGES_START,
    fetchSocialPostingPackagesGenerator
  );
}

export function* fetchHighlightedPackages() {
  yield takeLatest(actions.FETCH_HIGHLIGHTED_PACKAGES_START, fetchHighlightedPackagesGenerator);
}

export function* fetchTopResultPackages() {
  yield takeLatest(actions.FETCH_TOP_RESULT_PACKAGES_START, fetchTopResultPackagesGenerator);
}

export default function* rootSaga() {
  yield all([
    spawn(fetchPackages),
    spawn(fetchSocialPostingPackages),
    spawn(fetchHighlightedPackages),
    spawn(fetchTopResultPackages),
  ]);
}
